import React from 'react'
import { connect } from 'react-redux'

import ConnectedPagination from './ConnectedPagination.jsx'

/**
 * @typedef {Object} ListProps
 * @property {Array} items
 * @property {boolean} isQuerying
 * @property {number} count
 */

const ConnectedList = props => {
    const {
        items, isQuerying, count, listKey, renderList, renderNoResults, renderError, errorMessage,
    } = props

    if (errorMessage) {
        return renderError ? renderError(errorMessage) : (
            <div className="message-box-danger">
                {errorMessage}
            </div>
        )
    }

    return (
        <>
            {(!items.length && !isQuerying) ? renderNoResults() : renderList({ items, isQuerying, count })}
            {!!count && <ConnectedPagination listKey={listKey} />}
        </>
    )
}

const mapStateToProps = (state, { listKey }) => {
    const { items, isQuerying, pageSize, errorMessage } = state[listKey]
    return {
        items,
        isQuerying,
        count: pageSize,
        listKey,
        errorMessage,
    }
}

/**
 * A paginated list, connected to the given list reducer.
 * @param {Object} props
 * @param {string} props.listKey Key of the list reducer in the global state
 * @param {(listProps: ListProps) => React.ReactNode} props.renderList Render prop for the list
 * @param {() => React.ReactNode} props.renderNoResults Render prop for when there are no list items
 * @param {(message: string) => React.ReactNode} [props.renderError] Render prop to override list errors
 */
export default connect(mapStateToProps)(ConnectedList)
